
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.667 23.498a2.239 2.239 0 01-1.592-.658 2.252 2.252 0 01.001-3.182l7.414-7.41a4.538 4.538 0 00-2.642-.852.75.75 0 01-.746-.834 3.928 3.928 0 00-.841-2.908A3.925 3.925 0 003.613 6.19l-1.136-.104a.752.752 0 01-.462-1.278A11.919 11.919 0 0110.5 1.293c2.939 0 5.743 1.064 7.937 3.003l.549-.549a.744.744 0 011.06 0c.142.141.22.33.22.53s-.078.389-.22.53l-.549.549a11.941 11.941 0 013.003 7.936c0 3.205-1.248 6.219-3.515 8.485a.755.755 0 01-.784.176.753.753 0 01-.493-.635l-.1-1.051c-.183-2.02-1.913-3.602-3.939-3.602-.119 0-.24.005-.359.016l-.082.008a.753.753 0 01-.831-.745 4.54 4.54 0 00-.848-2.636l-7.413 7.409a.751.751 0 001.061 1.061.744.744 0 011.06 0c.142.142.22.33.22.531s-.078.389-.22.53a2.224 2.224 0 01-1.59.659zm9.182-8.328c2.49.083 4.622 1.893 5.151 4.293a10.49 10.49 0 002.001-6.169c0-2.804-1.092-5.441-3.075-7.425a10.432 10.432 0 00-7.425-3.075c-2.225 0-4.382.704-6.164 1.997a5.418 5.418 0 013.099 1.926 5.455 5.455 0 011.19 3.228 6.052 6.052 0 013.446 1.674.39.39 0 01.106.107 6.048 6.048 0 011.671 3.444z"}})])
          )
        }
      }
    